import styled from "styled-components";
import { theme } from "../theme";

export const StyledSidemenu = styled.nav`
	width: 100%;
	ul {
		display: flex;
		flex-direction: column;
		list-style: none;
		font-size: 1.6rem;
		font-family: ${theme.font.secondary};
		font-weight: 700;
	}
`;
